<template>
  <div class="dashboard-widget-settings">
    <el-form
      label-position="left"
      label-width="200px"
      style="width: 700px"
      size="mini"
    >
      <el-form-item label="Показывать договорённости встреч">
        <el-radio-group v-model="localValue.mode">
          <el-radio-button
            v-for="opt in $oneToOneConstants.meetings.modeSelectOptions"
            :key="opt.id"
            :label="opt.id"
          >{{ opt.name }}</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="Статус выполнения">
        <el-radio-group v-model="localValue.doneFilter">
          <el-radio-button label="pending">Невыполненные</el-radio-button>
          <el-radio-button label="overdue">Просроченные</el-radio-button>
          <el-radio-button label="done">Выполненные</el-radio-button>
          <el-radio-button label="all">Все</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="Кол-во записей в списке">
        <el-slider v-model="localValue.limit" :min="1" :max="50" show-input input-size="mini"></el-slider>
      </el-form-item>

      <el-form-item label="Открывать в новом окне">
        <el-switch v-model="localValue.openInNewWindow"></el-switch>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {Constants as $oneToOneConstants} from "@/modules/oneToOne/base/oneToOneConstants";

export default {
  name: 'OneToOneAgreementsWidgetSettings',
  props: {
    additionalTabs: {type: Array},
    value: {type: Object, required: true},
  },
  computed: {
    localValue: {
      get() {return this.value},
      set(value) {this.$emit('input', value)}
    },
    $oneToOneConstants() {
      return $oneToOneConstants;
    },
  },
  data() {
    return {}
  },
  methods: {}
}
</script>
